import React from 'react';

import { Paragraph } from '../components/Paragraph';
import { Subtitle } from '../components/Subtitle';

export const Testimonials = () => {
  return (
    <>
      <Subtitle>Testimonials</Subtitle>
      <Paragraph>
        Glints posts Users’ testimonials on the Site, which may contain
        personally identifiable information such as the Users’ names. Glints
        does obtain the Users’ consent prior to posting the testimonials to post
        their names along with their testimonials.
      </Paragraph>
    </>
  );
};
